import QueryString from 'qs';
import cleanQueryParams from './cleanQueryParams';
import parseQueryString from './parseQueryString';

/*
 * Take a path and parse that into path and query params
 *
 * @param {string} the path + query params
 * @returns {obj} {path, queryParams}
 */
export default function parsePathAndQueryParams(fullPath: string): {
  path: string;
  queryParams: string;
} {
  fullPath = cleanQueryParams(fullPath);
  const parts = fullPath.split('?');
  const path = parts[0];
  let queryParams = '';

  if (parts.length > 1) {
    queryParams = QueryString.stringify(parseQueryString(parts[1]));
  }

  return {
    path,
    queryParams,
  };
}
